const AUTH_REDIRECT_URL = process.env.VUE_APP_AUTH_REDIRECT_URL;

export function redirectToAuthPortal() {
  if (AUTH_REDIRECT_URL) {
    location.href = AUTH_REDIRECT_URL;
    return true;
  }

  return false;
}

export function handleProductionAuthRedirect(next, fallback) {
  if (process.env.NODE_ENV === "production" && redirectToAuthPortal()) {
    return;
  }

  return fallback();
}
